module.exports = {"340828100":"天堂镇","340828101":"店前镇","340828102":"来榜镇","340828103":"菖蒲镇","340828104":"头陀镇","340828105":"白帽镇","340828106":"温泉镇","340828107":"响肠镇","340828108":"河图镇","340828109":"五河镇","340828110":"主簿镇","340828111":"冶溪镇","340828112":"黄尾镇","340828200":"毛尖山乡","340828201":"莲云乡","340828202":"青天乡","340828203":"包家乡","340828204":"古坊乡","340828205":"田头乡","340828206":"中关乡","340828207":"石关乡","340828208":"姚河乡","340828209":"和平乡","340828210":"巍岭乡","340828400":"安徽岳西县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340828.json
// module id = 1012
// module chunks = 0